import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint @typescript-eslint/no-use-before-define: 0 */
import { useMemo } from 'react';
import { Client, Server } from 'styletron-engine-atomic';
import { DebugEngine, Provider as StyletronProvider } from 'styletron-react';
import { useDocument } from '../spacewebProvider/DocumentProvider';
export var SPACEWEB_STYLE_PREFIX = 'sw--';
export var SPACEWEB_STYLE_CONTAINER_ID = 'spaceweb-style-cache';
export var isServer = typeof window === 'undefined';
var NoopDebugEngine = /** @class */ (function () {
    function NoopDebugEngine() {
        this.debug = function () { return ''; };
    }
    return NoopDebugEngine;
}());
// NOTE: Define styletron as module variable (singleton)
var styletron;
var hasStyletron = function () { return typeof styletron !== 'undefined'; };
// Throws and error if not called from the server.
var ensureServer = function () {
    if (!isServer) {
        throw new Error('This method can only be called from the server.');
    }
};
// Throws and error if called from the server.
var ensureClient = function () {
    if (isServer) {
        throw new Error('This method can only be called from the browser.');
    }
};
// Throws an error if Styletron engine is not initialized (`getStyleEngine`).
var ensureEngine = function () {
    if (!hasStyletron())
        throw new Error("Styletron engine hasn't been initialized.");
};
export var hydrate = function (ownerDocument) {
    return (ownerDocument || document).getElementsByClassName('_spaceweb_hydrate_');
};
// Gets isomorphic Styletron engine.
export var getStyleEngine = function (ownerDocument) {
    if (isServer) {
        if (typeof styletron !== 'undefined')
            return styletron;
        styletron = new Server({ prefix: SPACEWEB_STYLE_PREFIX });
    }
    else {
        var doc = ownerDocument || document;
        var el = doc.getElementById(SPACEWEB_STYLE_CONTAINER_ID);
        if (el && styletron) {
            return styletron;
        }
        // adds a style tag in document.head to make sure only one instance of styletron is created in an app.
        appendCacheContainer(ownerDocument);
        styletron = new Client({
            hydrate: hydrate(ownerDocument),
            prefix: SPACEWEB_STYLE_PREFIX,
        });
    }
    return styletron;
};
// @ts-ignore
StyletronProvider.displayName = 'StyletronProvider';
// Style engine provider (a.k.a. StyletronProvider).
export var StyleProvider = function (props) {
    var doc = useDocument();
    var debugEngine = useMemo(function () { return (props.debug ? new DebugEngine() : new NoopDebugEngine()); }, [props.debug]);
    return (_jsx(StyletronProvider, __assign({ debug: debugEngine, value: props.styleEngine || getStyleEngine(doc), debugAfterHydration: !!props.debug }, { children: props.children }), void 0));
};
StyleProvider.displayName = 'StyleProvider';
// Gets hydration stylesheets as `Sheet[]` (e.g. Next.js).
export var getStylesheets = function () {
    ensureServer();
    ensureEngine();
    return styletron.getStylesheets();
};
// Gets hydration stylesheets HTML code as string.
export var getStylesheetsHtml = function () {
    ensureServer();
    ensureEngine();
    return styletron.getStylesheetsHtml();
};
// Appends cache styles to the DOM and returns element's instance.
export var appendCacheContainer = function (ownerDocument) {
    ensureClient();
    var doc = ownerDocument || document;
    var el = doc.getElementById(SPACEWEB_STYLE_CONTAINER_ID);
    if (el)
        return el;
    el = doc.createElement('style');
    el.id = SPACEWEB_STYLE_CONTAINER_ID;
    doc.head.appendChild(el);
    return el;
};
